const pluralize = require("pluralize");

export const MaybePluralize = (word, number) =>
  number === 1 ? word : pluralize(word);
